import {
  Component,
  OnInit,
  AfterViewInit,
  AfterContentChecked,
  ViewChild,
  ViewContainerRef,
  Renderer2,
  HostListener,
  Output,
  Input,
  EventEmitter
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PopupModalService } from "../../services/popup-modal.service";
import {
  windowService
} from '../../services';

@Component({
  selector: "sign-on-header",
  templateUrl: "./sign-on-header.component.html"
})
export class SignOnHeaderComponent {
  @Input() branding: any;
  @Input() pageData: any;
  isBestBuy: boolean = false;
  isSear: boolean= false;
  isSyw: boolean= false;
  isSunoco: boolean= false;
  isThd: boolean= false;
  isThdca: boolean= false;
  constructor(
    private _route: ActivatedRoute,
    private popupService: PopupModalService,
    private windowService: windowService
  ) { }

  brandId: any;
  partnerLogoAda: any;
  siteId: any;

  ngOnInit() {
    this._route.queryParams.subscribe((qParam: Params) => {
      if (Object.keys(qParam).length > 0) {
          if(qParam.brandId)
            this.brandId = qParam.brandId.toLowerCase();
            this.siteId = qParam.siteId.toUpperCase();
            if(this.siteId && this.siteId=="PLCN_BESTBUY"){
              this.isBestBuy = true;
            }
            if(this.siteId && this.siteId=="SEARS"){
              this.isSear = true;
            }
            if(this.siteId && this.siteId=="PLCN_SYW"){
              this.isSyw = true;
            }
            if(this.siteId && this.siteId=="PLOC_SUNOCO"){
              this.isSunoco = true;
            }
            if(this.siteId && this.siteId=="PLCN_HOMEDEPOT"){
              this.isThd = true;
            }
            if(this.siteId && this.siteId=="CACN_HOMEDEPOT"){
              this.isThdca = true;
            }
            console.log("check", this.siteId)
      }
    });
    

    // SignOn partner logo ADA 
    if (this.pageData && this.pageData.config$$rule_partner_catalog_contact_us) {
      var ruleResponse = this.pageData.config$$rule_partner_catalog_contact_us.ruleResponse[0];
      var configCatalogId = "config$$" + ruleResponse;
      var catalogContent = this.pageData[configCatalogId];
      if (catalogContent) {
        if(this.brandId && this.brandId=="jm"){
          this.partnerLogoAda = catalogContent.acq_partner_brand_jm;
        } else if(this.brandId && this.brandId=="bl"){
          this.partnerLogoAda = catalogContent.acq_partner_brand_bl;
        } else if(this.brandId && this.brandId=="am"){
          this.partnerLogoAda = catalogContent.acq_partner_brand_am;
        }else{ 
          this.partnerLogoAda = catalogContent.acq_partner_name;
        }
      }
    }

  }


  clickAction(event) {
    let link = event.currentTarget.href;
    //if (/^http/.test(link) && (link.indexOf(this.windowService.nativeWindow.location.origin) < 0) && (link.indexOf("citiretailservices.citibankonline.com") < 0)) {
      let obj = {};
      let hostRegex = /^(?:https?:\/\/)?(?:www\.)?/i;
      let nonCappedDomainName = window.location.host.toLowerCase().replace(hostRegex, '');
      let InitiCapedDomainName = nonCappedDomainName.charAt(0).toUpperCase() + nonCappedDomainName.slice(1);
      obj["fullHref"] = link;
      obj["host"] = InitiCapedDomainName;
      obj["target"] = '';
      this.popupService.openPopupContent.emit({
        popupContentComponent: "popup-site-redirect",
        popupContentParams: obj
      });
    //}
    //else {
      //this.windowService.nativeWindow.location.href = link;
    //}
  }
  clickAction_link(event) {
    event.preventDefault();
    let link = event.currentTarget.href;
    //if (/^http/.test(link) && (link.indexOf(this.windowService.nativeWindow.location.origin) < 0) && (link.indexOf("citiretailservices.citibankonline.com") < 0)) {
      let obj = {};
      let hostRegex = /^(?:https?:\/\/)?(?:www\.)?/i;
      let nonCappedDomainName = window.location.host.toLowerCase().replace(hostRegex, '');
      let InitiCapedDomainName = nonCappedDomainName.charAt(0).toUpperCase() + nonCappedDomainName.slice(1);
      obj["fullHref"] = link;
      obj["host"] = InitiCapedDomainName;
      obj["target"] = '';
      this.popupService.openPopupContent.emit({
        popupContentComponent: "popup-site-redirect",
        popupContentParams: obj
      });
    //}
    //else {
      //this.windowService.nativeWindow.location.href = link;
    //}
  }
}